import React from 'react';
import { Container, Row, Col, Card, Badge, ListGroup } from 'react-bootstrap';

const Education = () => {
  const university = {
    institution: "University of Bath",
    degree: "BSc (Hons) Computer Science",
    period: "Sep 2022 - July 2025",
    details: [
        "First Class"
    ]
  };
  
  const aLevels = {
      school: "King's College London Mathematics School",
      period: "Sep 2020 - June 2022",
      subjects: [
          { name: "Mathematics", grade: "A*" },
          { name: "Further Mathematics", grade: "A*" },
          { name: "Physics", grade: "A*" }
      ],
      asLevel: { name: "Computer Science", grade: "A" },
      epq: { name: "Computer Science Artefact", grade: "A*" }
  };

  const gcses = {
      school: "Gunnersbury Catholic School For Boys",
      period: "Sep 2015 - June 2020",
      grades: [
          { subject: "Mathematics", grade: "9" },
          { subject: "English Language", grade: "9" },
          { subject: "English Literature", grade: "8" },
          { subject: "Biology", grade: "9" },
          { subject: "Chemistry", grade: "9" },
          { subject: "Physics", grade: "9" },
          { subject: "Computer Science", grade: "9" },
          { subject: "Geography", grade: "9" },
          { subject: "French", grade: "9" },
          { subject: "Religious Studies", grade: "9" }
      ],
      other: { subject: "Further Mathematics", grade: "9", type: "AQA Level 2 Certificate" }
  };

  const certifications = [
    {
      name: "AWS Certified Cloud Practitioner",
      issuer: "Amazon Web Services",
      date: "June 2025",
      badge: "AWS"
    }
  ];

  return (
    <Container className="py-5">
      <h1 className="pb-2 mb-4"><i className="bi bi-mortarboard-fill"></i> Education</h1>

        {/* Certifications */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5" className="fw-bold text-primary">
          Certifications
        </Card.Header>
        <Card.Body>
          <ListGroup variant="flush">
            {certifications.map((cert, i) => (
              <ListGroup.Item key={i} className="d-flex justify-content-between align-items-center">
                <div>
                  <strong>{cert.name}</strong>
                  <br />
                  <small className="text-muted">{cert.issuer}</small>
                </div>
                <div className="text-end">
                  <Badge bg="info" text="dark" className="me-2">{cert.badge}</Badge>
                  <Badge bg="secondary" pill>{cert.date}</Badge>
                </div>
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card.Body>
      </Card>
      
      {/* University */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5" className="fw-bold text-primary d-flex justify-content-between align-items-center">
          {university.institution}
          <Badge bg="dark" text="light" className="p-2">{university.period}</Badge>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
                <h6 className="fw-bold">{university.degree}</h6>
                <ListGroup variant="flush">
                    {university.details.map((detail, i) => (
                        <ListGroup.Item key={i} className="d-flex justify-content-between align-items-center">
                            {detail}
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      
      {/* A-Levels */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5" className="fw-bold text-primary d-flex justify-content-between align-items-center">
          {aLevels.school}
          <Badge bg="dark" text="light" className="p-2">{aLevels.period}</Badge>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h6 className="fw-bold">Advanced Level</h6>
              <ListGroup variant="flush">
                {aLevels.subjects.map((s, i) => (
                  <ListGroup.Item key={i} className="d-flex justify-content-between align-items-center">
                    {s.name} <Badge bg="success" pill>{s.grade}</Badge>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Col>
            <Col md={6} className="mt-3 mt-md-0">
                <h6 className="fw-bold">Advanced Subsidiary</h6>
                <ListGroup variant="flush" className="mb-3">
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        {aLevels.asLevel.name} <Badge bg="success" pill>{aLevels.asLevel.grade}</Badge>
                    </ListGroup.Item>
                </ListGroup>
                <h6 className="fw-bold">Extended Project (EPQ)</h6>
                <ListGroup variant="flush">
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        {aLevels.epq.name} <Badge bg="success" pill>{aLevels.epq.grade}</Badge>
                    </ListGroup.Item>
                </ListGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      
      {/* GCSEs */}
      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5" className="fw-bold text-primary d-flex justify-content-between align-items-center">
          {gcses.school}
          <Badge bg="dark" text="light" className="p-2">{gcses.period}</Badge>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              <h6 className="fw-bold">GCSE</h6>
              <ListGroup variant="flush">
                {gcses.grades.map((g, i) => (
                  <ListGroup.Item key={i} className="d-flex justify-content-between align-items-center">
                    {g.subject} <Badge bg="success" pill>{g.grade}</Badge>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </Col>
            <Col md={6} className="mt-3 mt-md-0">
                <h6 className="fw-bold">{gcses.other.type}</h6>
                <ListGroup variant="flush">
                    <ListGroup.Item className="d-flex justify-content-between align-items-center">
                        {gcses.other.subject} <Badge bg="success" pill>{gcses.other.grade}</Badge>
                    </ListGroup.Item>
                </ListGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Education; 